import {charcoal} from '../sass/base/_exports.sass';

export const AlertLineIcon = ({color = charcoal, className = '', ratio = 1}) => {
  // default dimensions
  const width = 32;
  const height = 32;

  // Use ratio to calculate width and height
  const style = {height: `${ratio * height}px`, width: `${ratio * width}px`};

  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: Fix me!
    <svg
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      style={style}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 29.3333C8.63596 29.3333 2.66663 23.364 2.66663 16C2.66663 8.63599 8.63596 2.66666 16 2.66666C23.364 2.66666 29.3333 8.63599 29.3333 16C29.3333 23.364 23.364 29.3333 16 29.3333ZM16 26.6667C18.8289 26.6667 21.542 25.5428 23.5424 23.5425C25.5428 21.5421 26.6666 18.829 26.6666 16C26.6666 13.171 25.5428 10.4579 23.5424 8.45752C21.542 6.45713 18.8289 5.33332 16 5.33332C13.171 5.33332 10.4579 6.45713 8.45749 8.45752C6.4571 10.4579 5.33329 13.171 5.33329 16C5.33329 18.829 6.4571 21.5421 8.45749 23.5425C10.4579 25.5428 13.171 26.6667 16 26.6667ZM14.6666 20H17.3333V22.6667H14.6666V20ZM14.6666 9.33332H17.3333V17.3333H14.6666V9.33332Z"
        fill={color}
      />
    </svg>
  );
};
